import { render, staticRenderFns } from "./MyData.vue?vue&type=template&id=3274dce6&"
import script from "./MyData.js?vue&type=script&lang=js&"
export * from "./MyData.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports